import React, {Fragment} from "react";

import DatePickerControl from "../ui/DatePickerControl";
import { SmartErrorDiv } from ".";

const FormInputDatePicker = ( { control, width, readOnly, label, sectionName, name, style, className, formErrors, maxLength, required, maxDate } ) =>
{
    if ( control === undefined )
    {
        console.error ( "You must pass a react-hook-form control to this component") ;
    }

    const classText = className === undefined ? "form-control" : '' ;
    const styleObj = style === undefined ? {} : style ;

    const validateEndEventDate = ( val ) =>
    {
        if (val === null && required === true )
        {
            return "Please select a date";
        }
    }

    const placeHolder = readOnly ? null : 'Please Select Date' ;

    return (
        <Fragment>
            <label className='col-form-label'>{label}</label>
            <DatePickerControl name={sectionName + '.' + name} control={control}
                               validate={validateEndEventDate}
                               placeHolder={placeHolder} readOnly={readOnly}
                               showTimeInput={false}
                               maxDate={maxDate}/>
            <SmartErrorDiv sectionName={sectionName}  name={name} maxLength={maxLength} formErrors={formErrors} />
        </Fragment>
    )
}

export { FormInputDatePicker };
